<template>
<div class="grid__content">
    <div v-if="getLogin" class="grid__main-content">
        <scrollbar class="container">
            <div class="container-content">
                <tabs>
                    <tab :name="'Основное'" :selected="true">
                        <personal-info></personal-info>
                    </tab>
                    <tab :name="'Смена пароля'" >
                        <change-pass></change-pass>
                    </tab>
                    <tab :name="'Права'">
                        <div class="personal-inf">
                            <div class="personal-inf__item">
                                <div class="personal-inf__title">Чат</div>
                                <ul class="personal-inf__list">
                                    <li>–  Писать в чат-комнатах обсуждения инструментов</li>
                                </ul>
                                <div class="personal-inf__title">Роль</div>
                                <ul class="personal-inf__list">
                                    <li>–  Пользователь сайта</li>
                                </ul>
                            </div>
                        </div>
                    </tab>
                </tabs>
            </div>
        </scrollbar>
    </div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import Input from "../ui-components/reg-input"
import InputPass from "../ui-components/reg-input-pass"
import Tab from "../ui-components/ui-tab"
import Tabs from "../ui-components/ui-tabs"
import PersonalInfo from "./sig-personal-info"
import ChangePass from "./sig-personal-change-pass"
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
    components : {
        'input-reg':Input,
        'input-pass':InputPass,
        'tab':Tab,
        'tabs':Tabs,
        'personal-info':PersonalInfo,
        'change-pass':ChangePass,
        "scrollbar":VuePerfectScrollbar,
    },
    computed: {
        ...mapGetters({
            getLogin:'auth/getInfoUser'
        })
    }
}
</script>
<style lang="less">
.container {
    height: 100%;
}
.container-content {
    width: 912px;
    margin: 0 auto;
    padding-top: 70px;
    margin-bottom: 23px;
}
.personal-inf {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    width: 100%;
    &__item {
        width: 444px;
    }
    &__list {
        font-family: Arimo;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: 0.4px;
        color: #cae9ff;
    }
}
.personal-inf__title {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 3;
    letter-spacing: 0.4px;
    text-align: left;
    color: #ffffff;
}
</style>

